import React, { useState } from 'react';
import Flatpickr from 'react-flatpickr'

const DynamicFieldModal = ({ close, field_values }) => {
  const [value, setValue] = useState('');
  const [date, setDate] = useState(new Date().toLocaleDateString());
  const [values, setValues] = useState(field_values ? field_values : []);
  const [editing, setEditing] = useState(false);
  const [editingField, setEditingField] = useState(null);
  const [id, setID] = useState(null);

  const removeValue = (field_id) => {
    setValues(values.filter(item => item.id !== field_id));
  };

  const update = () => {
    if (editing) {
      setValues(values.map(item => {
        if (item.id == id) {
          return {
            id: id,
            value: value,
            date: date
          }
        }
        return item;
      }));
    } else {
      setValues([...values, { id: values.length + 1,  value: value, date: date }]);
    }
    clear();
  };

  const clear = () => {
    setValue('');
    setDate(new Date().toLocaleDateString());
    setEditing(false);
    setEditingField(null);
    setID(null);
  };

  return (
    <div>
  <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
    <div className="bg-white mx-auto rounded shadow p-5 text-center cu-width-input">
      {values.map((field, index) => (
        <div key={index} className='d-flex justify-content-between align-items-center mb-2'>
          <p>{field.value} ({field.date})</p>
          <button
            type='button' 
            className='btn btn-icon' 
            style={{border: 'none'}}
          >
            <i 
              className='fa fa-pencil text-primary mr-2'
              onClick={() => {setEditing(true); setEditingField(field); setValue(field.value); setDate(field.date); setID(field.id)}}
            >
            </i>
            <i 
              className='fa fa-trash text-danger'
              style={{fontSize: '1.2rem'}}
              onClick={() => removeValue(field.id)} 
            >
            </i>
          </button>
        </div>
      ))}

      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <label htmlFor="value">Value</label>
            <div className="input-group">
              <input value={value} onChange={e => setValue(e.target.value)} className="form-control" />
              {editing && (
                <div className="input-group-append">
                  <button className="btn btn-light btn-border" type="button" onClick={clear}>Clear</button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-md-12">
          <div className="form-group">
            <label htmlFor="date">Date</label>
            <Flatpickr value={date} onChange={(date, dateStr) => setDate(dateStr)} className="form-control" />
          </div>
        </div>
      </div>

      <div className="pt-3">
        <button onClick={update} type="button" className="btn btn-primary mr-2" disabled={!date || !value}>
          {editing ? 'Update' : 'Add'}
        </button>
        <button onClick={() => close(values)} type="button" className="btn btn-danger mr-2">
          Close
        </button>
      </div>
    </div>
  </div>
</div>
  );
};

export default DynamicFieldModal;